import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unlock-account-dialog',
  templateUrl: './unlock-account-dialog.component.html',
  styleUrls: ['./unlock-account-dialog.component.less']
})
export class UnlockAccountDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<UnlockAccountDialogComponent>
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}